import firebase from "firebase";
import Loader from "@/components/loader/Loader.vue";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import {DigitalSignageDevice} from "@/models/digital-signage/DigitalSignageDevice";

export default {
  name: "ManageDevicesDlg",
  components: {
    Loader,
    ConfirmDlg
  },
  data() {
    return {
      loading: {
        get: true,
        save: false
      },
      dialog: false,
      devices: [],
      editedDevices: []
    }
  },
  computed: {
    facilityId() {
      return this.$store.state.authModule.currentFacility;
    },
    digitalSignageDevices(): DigitalSignageDevice[] {
      return this.$store.state.digitalSignageModule.digitalSignageDevices;
    }
  },
  methods: {
    open() {
      this.dialog = true;
      this.$store.dispatch("getDigitalSignageDevices")
        .then(() => {
          this.loading.get = false;
          this.devices = JSON.parse(JSON.stringify(this.digitalSignageDevices));
        }).catch((err) => {
          this.showError(err);
      })
    },
    close() {
      this.editedDevices = [];
      this.dialog = false;
    },
    isEdit(deviceId) {
      return this.editedDevices.find(x => x.id === deviceId);
    },
    editDevice(device) {
      this.editedDevices.push(device);
    },
    removeDeviceFromEdited(deviceId) {
      this.editedDevices = this.editedDevices.filter(x => x.id !== deviceId);
      const device = this.digitalSignageDevices.find(x => x.id === deviceId);

      this.devices.forEach((x) => {
        if(x.id === deviceId) {
          x.deviceNameEdited = device.deviceNameEdited;
        }
      });
    },
    deleteDevice(device) {
      this.$refs.ConfirmDlg.open(
        null,
        this.$t("ManageDevices.DeleteDeviceQuestion"),
        false
      ).then(async response => {
        if (response && response.agree) {
          const digitalSignageRef = await firebase.firestore().collection("digitalSignage").doc(device.digitalSignageId);
          await digitalSignageRef.collection("devices").doc(device.id).delete();

          await this.$store.dispatch("getDigitalSignageDevices");

          this.$toast.open({
            type: "success",
            message: this.$t("ManageDevices.DeleteDeviceSuccessfully")
          });

          this.devices = JSON.parse(JSON.stringify(this.digitalSignageDevices));
          this.editedDevices = this.editedDevices.filter(x => x.id !== device.id);
        }
      }).catch((err) => {
        this.showError(err);
      })
    },
    async saveChanges() {
      if (this.editedDevices.length) {
        this.loading.save = true;

        try {
          const updatePromises = this.editedDevices.map(async device => {
            const digitalSignageRef = firebase.firestore().collection("digitalSignage").doc(device.digitalSignageId);
            const deviceDocRef = digitalSignageRef.collection("devices").doc(device.id);
            return deviceDocRef.update({ deviceNameEdited: device.deviceNameEdited });
          });

          await Promise.all(updatePromises);
          await this.$store.dispatch("getDigitalSignageDevices");

          this.$toast.open({
            type: "success",
            message: this.editedDevices.length > 1 ? this.$t("ManageDevices.SaveDevicesSuccessfully") : this.$t("ManageDevices.SaveDeviceSuccessfully")
          });

          this.loading.save = false;
          this.editedDevices = [];

        } catch (err) {
          this.showError(err);
        }
      }
    },
    showError(err) {
      this.$toast.open({
        type: "error",
        message: this.$t("GeneralTranslations.UnhandledError")
      });
      console.error("ERROR: ", err.message);
    }
  }
}